import { debounce } from 'quasar'
import { profileService } from '@/services'
import { useAuthStore } from '@/stores/auth'

/** @type {Record<string, unknown>} */
let pendingDelta = {}

function mergePreferenceDelta(acc, delta) {
  const out = { ...acc }
  if (delta.tables && typeof delta.tables === 'object') {
    out.tables = { ...(out.tables || {}), ...delta.tables }
  }
  if (delta.nav !== undefined) {
    out.nav = delta.nav
  }
  if (delta.grids !== undefined) {
    out.grids = delta.grids
  }
  if (delta.pos && typeof delta.pos === 'object') {
    out.pos = { ...(out.pos || {}), ...delta.pos }
  }
  if (delta.ui && typeof delta.ui === 'object') {
    out.ui = { ...(out.ui || {}), ...delta.ui }
  }
  return out
}

const runDebouncedFlush = debounce(async () => {
  const authStore = useAuthStore()
  const body = { ...pendingDelta }
  pendingDelta = {}
  if (Object.keys(body).length === 0) {
    return
  }
  try {
    const data = await profileService.patchPreferences(body)
    if (data?.preferences) {
      await authStore.mergeUserFromProfile({ preferences: data.preferences })
    }
  } catch (e) {
    console.warn('Failed to sync user preferences', e)
  }
}, 500)

/**
 * Queues a partial preferences PATCH; multiple calls within ~500ms are merged and sent once.
 * @param {Record<string, unknown>} partial
 */
export function schedulePreferencesPatch(partial) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return
  }
  pendingDelta = mergePreferenceDelta(pendingDelta, partial)
  runDebouncedFlush()
}
